module.exports = __webpack_public_path__ + "static/media/51.140d8152.png";